import packageJson from '../../../package.json'

export const severities = ['log', 'warn', 'error', 'info'] as const

export type AppLogger = Record<
  (typeof severities)[number],
  (...args: unknown[]) => void
>

export const createAppLogger = () =>
  severities.reduce(
    (logger, severity) =>
      ({
        // eslint-disable-next-line no-console
        [severity]: console[severity].bind(
          console,
          `${packageJson.name}@${packageJson.version}`,
        ),
        ...logger,
      }) as const,
    {} as AppLogger,
  )
